import { SIZE_DESKTOP, SIZE_TABLET, SIZE_PHONE, RESPONSIVE_BREAKPOINTS } from './constants'
import { requestAccountConfirmation } from '../utils/requests'
export const sendIRTrackingEvents = (kind, productId) => {
  window.adInsights.e('info-request', kind, 'timing', productId);
  sendAnalyticsEvent({ category: 'info-request', action: 'submit', label: kind })
}

export const sendAnalyticsEvent = (event, callback) => {
  if (!window.ga) return

  const eventType = event['event'] || 'event'
  const category = event['category'] || ''
  const action = event['action'] || ''
  const label = event['label'] || ''

  window.ga('send', eventType, category, action, label, { hitCallback: callback })
}

// Send the tracking pixel to Insights (there is no need to update the data attributes)
export const trackRegisteredDownload = link => {
  if (typeof window.adInsights !== 'undefined') {
    window.adInsights.e(link.dataset.insightsCategory.replace('-non-registered', ''),
      'click',
      link.dataset.insightsLabel,
      link.dataset.insightsValue)
  }
}

// function to close last step of registration step and avoid to go to MyAD
export const closeModalOnSignUpLastStepButton = () => {
  const lastStepButton = document.querySelector('.js_kth-sbs-last_step_cta')
  if (lastStepButton) {
    lastStepButton.addEventListener('click', e => e.preventDefault())
    lastStepButton.setAttribute('rel', 'kenneth-close-modal')
    lastStepButton.innerText = window.NFT.I18n.register_button_text
  }
}

export const requireAuthToDownload = (e, link, callback) => {
  e.stopPropagation();
  e.preventDefault();

  if (window.AD && window.AD.CurrentUser && !window.AD.CurrentUser.id) {
    window.AD.reload_on_login = false;
    window.AD.openWelcome(link);
    window.AD.callback = () => {
      window.AD.redirect_uri = location.href
      window.AD.load_upper_menu()
      closeModalOnSignUpLastStepButton()
      callback(link);
    };
    return false;
  } else if ((window.AD.CurrentUser.id && !window.AD.CurrentUser.legacy_confirmed && !window.AD.CurrentUser.confirmed_at)) {
    // Add user email to modal    
    const userEmailText = document.querySelector('.user_mail_body');
    if (userEmailText && !userEmailText.innerHTML.includes(window.AD.CurrentUser.email))
      userEmailText.innerHTML += window.AD.CurrentUser.email;

    // Request confirmation and close modal
    const sendConfirmationButton = document.querySelector('.js-email-confirmation-cta')
    sendConfirmationButton &&
      sendConfirmationButton.addEventListener('click', () => {
        requestAccountConfirmation();
        window.AFD.modals.closeNow('#download_file_account_confirmation');
      });

    // Show modal  
    window.AFD.modals.open('#download_file_account_confirmation');
    return false
  }
  return callback(link);
}

/**
 * This tracks play events with Insights on video embeds with Vimeo and YouTube APIs
 */
export const initVideoTracking = () => {
  if (!window.adInsights || !window.Vimeo) return;
  if (!window.YT || !window.YT.Player) {
    document.addEventListener('youtubeapi:ready', initVideoTracking);
    return;
  }

  document.querySelectorAll('.vimeo-resource, .youtube-resource').forEach(item => {
    let videoItem;
    const { insightsCategory, insightsLabel, insightsValue, insightsVersion } = item.parentElement.dataset;
    if (item.className.includes('vimeo-resource')) {
      videoItem = new window.Vimeo.Player(item);
      videoItem.on('play', () => window.adInsights.e(insightsCategory, 'click', insightsLabel, insightsValue, insightsVersion));
      return;
    }
    videoItem = new window.YT.Player(item.id, {
      events: {
        'onStateChange': event => {
          if (event.data === window.YT.PlayerState.PLAYING) {
            window.adInsights.e(insightsCategory, 'click', insightsLabel, insightsValue, insightsVersion);
          }
        }
      }
    });
  });
}

export const requireCountryCode = callback => {
  if (window.AFD && window.AFD.countryCode) return callback();
  window.AFD = window.AFD || {};
  window.AFD.countryCodeCallbacks = [...(window.AFD.countryCodeCallbacks || []), callback];
}

export const scrollToElement = (element, smooth, offset = 0) => {
  const behavior = smooth ? 'smooth' : 'auto'
  if (offset) {
    const opts = {
      top: element.offsetTop + offset,
      behavior
    }
    window.scrollTo(opts)
  } else {
    element.scrollIntoView({ behavior })
  }
}

export const getDevice = () => {
  const widthWindow = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
  const { small, large } = RESPONSIVE_BREAKPOINTS
  return widthWindow >= large ? SIZE_DESKTOP : (widthWindow >= small ? SIZE_TABLET : SIZE_PHONE)
}

export const isRetina = () => window.devicePixelRatio >= 2

// Sets available viewport height considering mobile native navigation and browser controls
// Allows for full height containers to have fixed elements placed correctly
export const setMobileCSSCustomProperties = () => {
  const vh = window.innerHeight * 0.01
  document.documentElement.style.setProperty('--vh', `${vh}px`)
}

// TODO: Refactor this later and move accordion to its own partial
export const initAccordions = () => {
  var $category = $('.acordeon__category__title');
  var $content = $('.acordeon__content');
  var $arrow = $('.acordeon__arrow');
  var appear = 'acordeon--appear';
  var arrowUp = 'acordeon__arrow--up';

  function toggleAccordion(that) {
    var $parent = $(that).parent();
    var $brotherArrow = $parent.siblings('.acordeon__category').find($arrow);
    var $showContent = $parent.find($content);

    $parent.find($arrow).toggleClass(arrowUp);

    $brotherArrow.each(function () {
      if ($(this).hasClass(arrowUp)) {
        $(this).toggleClass(arrowUp);
      }
    });

    if (!$showContent.hasClass(appear)) {
      $content.removeClass(appear);
      $showContent.addClass(appear);

      // force call checkImpressions() once an acordeon is open
      setTimeout(function () { window.adInsights && window.adInsights.checkImpressions(); }, 500);
    } else {
      $showContent.removeClass(appear);
    }
  }

  $category.on('click', function () {
    if (AD.CurrentUser.id) {
      toggleAccordion(this)
    } else {
      var that = this
      AD.openWelcome(this)
      AD.reload_on_login = false
      AD.callback = function () {
        toggleAccordion(that)
      }
    }
  })
}

export const removeQuoteFormByDevice = quoteForm => {
  const quoteForms = document.querySelectorAll(quoteForm)
  if (!quoteForms.length) return

  quoteForms.forEach(form => {
    if (getDevice() !== SIZE_DESKTOP) form.dataset.device === 'desktop' && form.remove();
    else form.dataset.device === 'mobile' && form.remove();
  })
}